import {
    ADD_ADMIN_PROXIES,
    ADD_ADMIN_PROXIES_SUCCESS,
    ADD_ADMIN_PROXIES_FAILURE,
    UPDATE_ADMIN_PROXY,
    UPDATE_ADMIN_PROXY_SUCCESS,
    UPDATE_ADMIN_PROXY_FAILURE,
    GET_ADMIN_PROXY_LIST,
    GET_ADMIN_PROXY_LIST_SUCCESS,
    SET_UPDATE_POPUP,
    IMPERSONATE_ADMIN_PROXY,
    IMPERSONATE_ADMIN_PROXY_FAILURE,
    IMPERSONATE_ADMIN_PROXY_SUCCESS,
    TERMINATE_ADMIN_PROXY_SUCCESS,
    TERMINATE_ADMIN_PROXY_FAILURE,
    REVOKE_ADMIN_PROXIES,
    REVOKE_ADMIN_PROXIES_SUCCESS,
    REVOKE_ADMIN_PROXIES_FAILURE,
    GET_ADMIN_PROXY_USER_LIST,
    GET_ADMIN_PROXY_USER_LIST_FAILURE,
    GET_ADMIN_PROXY_USER_LIST_SUCCESS,
    SET_IMPERSONATION_STATUS,
    IS_SALES_ORG_INITIALIZED
} from 'src/pages/admin/redux/action/actionTypes.js';

const initialState = {
    status: '',
    loading: false,
    proxyList: [],
    addProxyStatus: '',
    updateProxyStatus: '',
    updatePopup: false,
    impersonationKey: '',
    statusCode: '',
    statusMessage: '',
    terminationStatusCode: '',
    proxyUserList: [],
    initiateProxyStatus: '',
    impersonationStatus: false,
    proxyUserListLoading: false,
    getProxyStatusCode:'',
    isSalesOrgInitialized: false
};

const AdminProxyReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ADMIN_PROXIES:
            return {
                ...state,
                loading: true,
                addProxyStatus: '',
            };
        case ADD_ADMIN_PROXIES_SUCCESS:
            return {
                ...state,
                loading: false,
                addProxyStatus: action.payload.statusCode,
            };
        case ADD_ADMIN_PROXIES_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case UPDATE_ADMIN_PROXY:
            return {
                ...state,
                loading: true,
                updateProxyStatus: '',
            };
        case UPDATE_ADMIN_PROXY_SUCCESS:
            return {
                ...state,
                loading: false,
                updateProxyStatus: action.payload.statusCode,
            };
        case UPDATE_ADMIN_PROXY_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case GET_ADMIN_PROXY_LIST:
            return {
                ...state,
                getProxyStatusCode: '',
                loading: true,
            };
        case GET_ADMIN_PROXY_LIST_SUCCESS:
            return {
                ...state,
                proxyList: action.proxyList,
                getProxyStatusCode: action.proxyList.statusCode,
                loading:false,
            };

        case SET_UPDATE_POPUP:
            return {
                ...state,
                updatePopup: action.payload,
            };
        case IMPERSONATE_ADMIN_PROXY:
            return {
                ...state,
                initiateProxyStatus: '',
            };
        case IMPERSONATE_ADMIN_PROXY_SUCCESS:
            return {
                ...state,
                impersonationKey: action.payload.impersonationKey,
                initiateProxyStatus: action.payload.statusCode,
                impersonationStatus: true,
                terminationStatusCode: '',
            };
        case IMPERSONATE_ADMIN_PROXY_FAILURE:
            return {
                ...state,
                terminationStatusCode: '',
            };

        case TERMINATE_ADMIN_PROXY_SUCCESS:
            return {
                ...state,
                impersonationKey: '',
                terminationStatusCode: action.payload.statusCode,
                initiateProxyStatus: '',
            };
        case TERMINATE_ADMIN_PROXY_FAILURE:
            return {
                ...state,
            };
        case REVOKE_ADMIN_PROXIES:
            return {
                ...state,
                loading: true,
                statusCode: '',
            };
        case REVOKE_ADMIN_PROXIES_SUCCESS:
            return {
                ...state,
                loading: false,
                statusMessage: action.payload.statusMessage,
                statusCode: action.payload.statusCode,
            };
        case REVOKE_ADMIN_PROXIES_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case GET_ADMIN_PROXY_USER_LIST:
            return {
                ...state,
                proxyUserList: '',
                proxyUserListLoading: true,
            };
        case GET_ADMIN_PROXY_USER_LIST_SUCCESS:
            return {
                ...state,
                proxyUserList: action.proxyUserList,
                proxyUserListLoading: false,
            };
        case GET_ADMIN_PROXY_USER_LIST_FAILURE:
            return {
                ...state,
                proxyUserList: '',
                proxyUserListLoading: false,
            };
            case SET_IMPERSONATION_STATUS:
                return {
                    ...state,
                    impersonationStatus: false,
                };
            case IS_SALES_ORG_INITIALIZED:
                return{
                     ...state,
                    isSalesOrgInitialized: action.payload,
                };

        default: {
            return { ...state };
        }
    }
};

export default AdminProxyReducer;
